import { useEffect } from 'react';

export default function MetaHead({ title, description, ogTitle, ogDescription, ogImage }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (description) {
      metaDesc.setAttribute('content', description);
    }

    let ogT = document.querySelector('meta[property="og:title"]');
    if (!ogT) {
      ogT = document.createElement('meta');
      ogT.setAttribute('property', 'og:title');
      document.head.appendChild(ogT);
    }
    if (ogTitle || title) {
      ogT.setAttribute('content', ogTitle || title);
    }

    let ogD = document.querySelector('meta[property="og:description"]');
    if (!ogD) {
      ogD = document.createElement('meta');
      ogD.setAttribute('property', 'og:description');
      document.head.appendChild(ogD);
    }
    if (ogDescription || description) {
      ogD.setAttribute('content', ogDescription || description);
    }

    if (ogImage) {
      let resolvedImage = ogImage;
      if (!resolvedImage.startsWith('http://') && !resolvedImage.startsWith('https://')) {
        const cleanPath = resolvedImage.replace(/^\/_assets\//, '').replace(/^\/assets\/[^/]+\//, '');
        resolvedImage = `https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/${cleanPath}`;
      }

      let ogI = document.querySelector('meta[property="og:image"]');
      if (!ogI) {
        ogI = document.createElement('meta');
        ogI.setAttribute('property', 'og:image');
        document.head.appendChild(ogI);
      }
      ogI.setAttribute('content', resolvedImage);

      let twI = document.querySelector('meta[name="twitter:image"]');
      if (!twI) {
        twI = document.createElement('meta');
        twI.setAttribute('name', 'twitter:image');
        document.head.appendChild(twI);
      }
      twI.setAttribute('content', resolvedImage);
    }
  }, [title, description, ogTitle, ogDescription, ogImage]);

  return null;
}
